"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultGroupComponent = DefaultGroupComponent;
const react_1 = __importDefault(require("react"));
function DefaultGroupComponent({ isClosedGroup, groupName, onToggleGroupClosed, translateGroupName, children }) {
    return (react_1.default.createElement("div", { key: groupName },
        groupName !== "" ? (react_1.default.createElement("div", { className: "group-container-header", onClick: () => onToggleGroupClosed(groupName) },
            react_1.default.createElement("button", { className: "expand-collapse" }, "\u00A0>>\u00A0"),
            translateGroupName(groupName))) : (""),
        react_1.default.createElement("table", null,
            react_1.default.createElement("tbody", null, isClosedGroup ? "" : children))));
}
//# sourceMappingURL=default-group-component.js.map